import * as React from 'react';
import { Link } from '../Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const RouterLink = _ref => {
  let {
    onClick,
    children,
    style
  } = _ref;
  return /*#__PURE__*/_jsx(Link, {
    style: style,
    onClick: onClick,
    children: children
  });
};